import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Bot, Loader2, Terminal, Sparkles, CalendarDays } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("alex@hermes.ai");
  const [password, setPassword] = useState("hermes123");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : err?.message;
      const network = !err?.response;
      setError(network ? "Cannot reach API. Is the backend running on :8000?" : (typeof detail === "string" ? detail : "Invalid email or password"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex">
      {/* Left brand panel */}
      <div className="hidden lg:flex w-1/2 flex-col justify-between p-12 bg-[hsl(245,45%,15%)] text-white relative overflow-hidden">
        <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[hsl(245,58%,55%)] opacity-30 blur-3xl" />
        <div className="relative">
          <div className="flex items-center gap-2.5">
            <div className="h-9 w-9 rounded-lg bg-white/15 flex items-center justify-center"><Bot className="h-5 w-5" /></div>
            <span className="text-[16px] font-semibold">BuddyOS by Tokenbuds</span>
          </div>
        </div>
        <div className="relative">
          <h1 className="text-[34px] font-semibold leading-tight tracking-tight">The AI-operated<br />growth engine.</h1>
          <p className="mt-4 text-[15px] text-white/70 max-w-md leading-relaxed">
            Your agent drafts, schedules and researches. You review and approve. API-first and terminal-first, built for a team of one.
          </p>
          <div className="mt-8 space-y-3 max-w-md">
            {[[Sparkles, "Personalized sequences drafted per person"], [CalendarDays, "Social calendar you approve and publish"], [Terminal, "Fully driveable via REST API & CLI"]].map(([Icon, t], i) => (
              <div key={i} className="flex items-center gap-3 text-[14px] text-white/85">
                <div className="h-8 w-8 rounded-lg bg-white/10 flex items-center justify-center"><Icon className="h-4 w-4" /></div>
                {t}
              </div>
            ))}
          </div>
        </div>
        <div className="relative text-[12px] text-white/40">Tokenbuds operating system · Hermes runtime</div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center p-6 bg-white">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <div className="h-9 w-9 rounded-lg brand-bg text-white flex items-center justify-center"><Bot className="h-5 w-5" /></div>
            <span className="text-[16px] font-semibold">BuddyOS by Tokenbuds</span>
          </div>
          <h2 className="text-[22px] font-semibold">Sign in</h2>
          <p className="text-[13.5px] text-[hsl(240,4%,48%)] mt-1">Welcome back. Enter your credentials.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="block text-[13px] font-medium mb-1.5">Email</label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email"
                className="w-full rounded-md border border-[hsl(240,6%,88%)] px-3 py-2 text-[14px] outline-none focus:ring-2 focus:ring-[hsl(245,58%,70%)]" />
            </div>
            <div>
              <label className="block text-[13px] font-medium mb-1.5">Password</label>
              <input value={password} onChange={(e) => setPassword(e.target.value)} type="password"
                className="w-full rounded-md border border-[hsl(240,6%,88%)] px-3 py-2 text-[14px] outline-none focus:ring-2 focus:ring-[hsl(245,58%,70%)]" />
            </div>
            {error && <div className="text-[13px] text-red-600">{error}</div>}
            <button type="submit" disabled={loading}
              className="w-full rounded-md brand-bg text-white py-2.5 text-[14px] font-medium hover:brightness-105 disabled:opacity-60 flex items-center justify-center gap-2">
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
            </button>
          </form>
          <div className="mt-5 rounded-lg bg-[hsl(240,5%,97%)] border border-[hsl(240,6%,92%)] px-3 py-2.5 text-[12.5px] text-[hsl(240,4%,45%)]">
            Demo account is pre-filled: <span className="font-mono">alex@hermes.ai / hermes123</span>
          </div>
        </div>
      </div>
    </div>
  );
}
